export const weatherKeys = {
  all: ["weather"] as const,
  details: () => [...weatherKeys.all, "detail"] as const,
  detail: (zipcode: string | undefined) =>
    [...weatherKeys.details(), zipcode] as const,
}
